module.exports = __webpack_public_path__ + "static/img/logo_red.8c25f58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_red.png
// module id = h0bA
// module chunks = 1